import { useEffect, useState } from "react";
import { ShapePreview } from "./common/ShapePreview";
import { ErrorBox } from "./common/ErrorBox";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { useFormContext } from "react-hook-form";

export const ShapePicker = ({
  name,
  label,
  title,
  detailed_label,
  options,
  validation,
  errors,
  selectedColor

}) => {
  console.log("re-render shpaePicker");

  const { register, setValue, trigger } = useFormContext();

  const handleColorClick = (code) => {
    setValue(name, code,{ shouldValidate: true });  
  };

  return (
    <div className={`space-y-2`}>
            <div className="flex justify-between">

      <h1 className="text-2xl uppercase text-blue-600 font-semibold dark:text-white">{title}</h1>

      <AiOutlineInfoCircle className="text-orange-400 text-xl" />
      </div>

      <p className="text-sm font-medium">{detailed_label}</p>
      <div className="grid grid-cols-[repeat(auto-fill,minmax(60px,1fr))] gap-4">
        {options.map((shape,i) => (
              <div key={i} className="flex flex-col items-center m-1">

              <ShapePreview code={shape.code} color={shape.color} diameter={60} handleColorClick={handleColorClick} label={shape.label} selected={selectedColor == shape.code} key={i} />
          <label className="text-xs mt-2 text-center">{shape.label}</label>
          </div>
        ))}
      </div>
      <input type="hidden" {...register(name, validation)} />
      <ErrorBox errors={errors} />

    </div>
  );
};
